import React, { DetailedHTMLProps, InputHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes } from "react"
import { useIntl } from "react-intl"
import styled from "styled-components"

import { COLORS, SIZES } from "src/layout/constants"

type InputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> &
  DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>

export const TextInput: React.FC<InputProps> = (props) => {
  const { formatMessage } = useIntl()
  const placeholder = formatMessage({ id: `input.${props.name}` })
  const Element = props.rows ? "textarea" : "input"
  return <Element placeholder={placeholder} {...props} />
}

type SelectProps = DetailedHTMLProps<SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement>

export const SelectInput: React.FC<SelectProps> = ({ children, ...props }) => {
  const { formatMessage } = useIntl()
  const placeholder = formatMessage({ id: `input.${props.name}` })
  return (
    <select {...props} style={{ color: props.value ? undefined : COLORS.grey }}>
      <option value="">{placeholder}</option>
      {children}
    </select>
  )
}

export const Form = styled.form`
  background-color: ${COLORS.light};
  padding: ${SIZES.margin}px;
  @media (max-width: 799px) {
    margin: ${SIZES.mobileMargin}px;
    padding: 20px 0;
  }
`

export const FormRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: ${SIZES.margin / 2}px auto;
  max-width: 800px;
  input,
  textarea,
  select {
    flex: 1;
    margin: 0 ${SIZES.margin / 2}px;
    border-bottom: 2px solid ${COLORS.black};
    padding: 10px 0;
    min-width: 200px;
  }
  button,
  label {
    margin: ${SIZES.margin / 2}px;
    svg {
      vertical-align: -11px;
      margin-right: 15px;
    }
  }
  @media (max-width: 799px) {
    margin: 0;
    input,
    textarea,
    select {
      margin: 5px ${SIZES.mobileMargin}px;
    }
  }
`

export const Attachment = styled.label`
  flex: 1;
  /* position: relative;
  input {
    position: absolute;
    margin: 0;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
    cursor: pointer;
    opacity: 0;
  } */
`

export const Submit = styled.button`
  background-color: ${COLORS.dark};
  border-radius: 40px;
  padding: 25px 60px;
  color: ${COLORS.white};
  text-transform: uppercase;
  font-weight: 500;
  &:disabled {
    background-color: ${COLORS.grey};
  }
`
